import withNavigate from "../../../routes/withNavigate";
import CandidateSearchContainer from "./CandidateSearchContainer.jsx";
import CandidateSearchStore from "./CandidateSearchStore";

export default CandidateSearchStore(withNavigate(CandidateSearchContainer));